import { render, staticRenderFns } from "./VatField.vue?vue&type=template&id=2de8d2dc&scoped=true"
import script from "./VatField.vue?vue&type=script&lang=js"
export * from "./VatField.vue?vue&type=script&lang=js"
import style0 from "./VatField.vue?vue&type=style&index=0&id=2de8d2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8d2dc",
  null
  
)

export default component.exports